import React, { FC } from 'react'
import { Plus, Eye, Trash2, Pencil } from 'lucide-react';
interface Props {
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  size?: number;
  disabled?: boolean;
}
export const EyeButton: FC<Props> = ({ type = 'button', onClick, size = 15, disabled = false }) => {
  return (
    <button
    type={type}
    onClick={onClick}
    className="text-inkMuted transition dark:text-inkMuted-dark hover:text-secondary-600 dark:hover:text-secondary-300 "
    disabled={disabled}
  >
    <Eye size={size} />
  </button>
  )
}

export const TrashButton: FC<Props> = ({ type = 'button', onClick, size = 15, disabled = false }) => {
  return (
    <button
    type={type}
    onClick={onClick}
    className="text-inkMuted transition dark:text-inkMuted-dark hover:text-red-500 dark:hover:text-red-300 "
    disabled={disabled}
  >
    <Trash2 size={size} />
  </button>
  )
}

export const PlusButton: FC<Props> = ({ type = 'button', onClick, size = 15, disabled = false }) => {
  return (
    <button
    type={type}
    onClick={onClick}
    className="text-inkMuted transition dark:text-inkMuted-dark hover:text-secondary-600 dark:hover:text-secondary-300 "
    disabled={disabled}
  >
    <Plus size={size} />
  </button>
  )
}

export const PencilButton: FC<Props> = ({ type = 'button', onClick, size = 15, disabled = false }) => {
  return (
    <button
    type={type}
    onClick={onClick}
    className="text-inkMuted transition dark:text-inkMuted-dark hover:text-secondary-600 dark:hover:text-secondary-300 "
    disabled={disabled}
  >
    <Pencil size={size} />
  </button>
  )
}